import {useTranslation} from "react-i18next";
import Collapsable from "../../common/Collapsable/Collapsable";
import {SettingsRowValue} from "../../common/CustomTable/CustomTable";
import React from "react";

function VeritoneServiceSettings(props) {
    const {t} = useTranslation(['thirdPartyService']);
    const {
        thirdPartyService,
        style,
        isDisabled
    } = props;

    return (
        <Collapsable label={t('thirdPartyService:label.veritoneSettings')}
            style={style} isDisabled={isDisabled}
        >
            <div className="settings-table">
                <div className="table-row-group">
                    <SettingsRowValue label={t('thirdPartyService:label.url')}
                        value={thirdPartyService.url} isDisabled={isDisabled}/>
                </div>
            </div>
        </Collapsable>
    )
}

export default VeritoneServiceSettings;
